// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6158) return "static/chunks/6158-c1fb3f83bee996cf.js";
	if (chunkId === 8139) return "static/chunks/8139-e52f13ad0940ad28.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3179":"3ddc9f734b79f5cf","5560":"992e7c4a390b743f","7573":"b3748590a4b6c27d","8640":"b5a24b55c3ac6bb2"}[chunkId] + ".js";
};